import React, { useEffect, useState } from "react";
import { Mail, Check } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

export default function AdminContacts() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/contacts").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const mark = async (id, status) => {
    await api.put(`/admin/contacts/${id}/status`, { status });
    toast.success("Updated"); load();
  };

  return (
    <div data-testid="admin-contacts">
      <h1 className="font-display text-3xl md:text-4xl font-medium text-primary mb-6">Contact Inbox</h1>
      <div className="space-y-4">
        {items.map((c) => (
          <div key={c.id} className="bg-card border border-primary/10 rounded-2xl p-5">
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="font-semibold text-primary">{c.name} <span className="text-muted-foreground font-normal">· {c.email}</span></p>
                <span className="inline-block text-xs uppercase tracking-wide font-semibold text-secondary mt-1">{c.topic}</span>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className={`text-xs px-2.5 py-1 rounded-full font-semibold ${c.status === "new" ? "bg-secondary/15 text-secondary" : "bg-muted text-muted-foreground"}`}>{c.status}</span>
                {c.status === "new" && <button onClick={() => mark(c.id, "read")} data-testid={`contact-read-${c.id}`} className="p-1.5 text-primary/60 hover:text-secondary"><Check size={16} /></button>}
              </div>
            </div>
            <p className="text-foreground/80 mt-3 leading-relaxed">{c.message}</p>
            <div className="flex items-center gap-4 mt-3 text-xs text-muted-foreground">
              <span>{new Date(c.created_at).toLocaleString()}</span>
              <a href={`mailto:${c.email}`} className="flex items-center gap-1 text-secondary font-semibold"><Mail size={13} /> Reply</a>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-muted-foreground">No messages yet.</p>}
      </div>
    </div>
  );
}
